import { Component, OnInit, ViewChild, Input, Output, EventEmitter, AfterViewInit, OnChanges, SimpleChanges, ElementRef } from '@angular/core';
import { Supervision, SupervisionStatusEnum } from 'solar-bo';
import { MatDialog } from '@angular/material/dialog';

//template: `<span matTooltip="{{tooltip}}"><i [ngClass]="class" ></i> {{statusName}} </span`


@Component({
    selector: "app-om-statusicon",
    template: `<span matTooltip="{{tooltip}}"><i [ngClass]="class" ></i> {{statusName}} </span>`
})
export class OMStatusIconComponent implements OnInit, OnChanges {
    @Input() status: string;
    statusName: string = "";
    @Input() showStatusName: boolean = true;
    @Input() supervision: Supervision;
    @Input() options: { readonly: boolean } = { readonly: false };
    @Output() statusChange: EventEmitter<any> = new EventEmitter();
    statusCanBeChanged: boolean = false;
    tooltip = "";
    class: string = "status status-error fas fa-exclamation-circle";

    constructor(private dialog: MatDialog
        ) { }

    ngOnInit() {
        //this.setClassByStatus(+this.status);
    }

    ngOnChanges() {
        this.setClassByStatus(this.status);
    }

    setClassByStatus(st?: string) {
        let newClass = "";
        let withpointer = "";
/*         if (this.options.readonly == false) {
            this.statusCanBeChanged = this.globService.checkAuthorizationById(ControlEnum.SUPERVISION_CHANGE_STATUS);
        } else {
            this.statusCanBeChanged = false;
        } */


        if (this.supervision) {
            st = this.supervision.info.status;
            this.status = st;

            withpointer = "  ";
        }
        if (this.statusCanBeChanged) {
            this.tooltip = "Click here to change status.";
            withpointer = " withpointer ";
        }

        if (st === 'TOREVIEW') {
            newClass = withpointer + " status status-warning fas fa-tasks";
            this.tooltip = "Panel issue must be reviewed.";
            this.statusName = "To review";
        } else if (st === 'PENDING') {
            newClass = "status status-warning far fa-clock";
            this.tooltip = "Panel issue review is pending.";
            this.statusName = "Pending";            
        } else if (st === 'INPROGRESS') {
            newClass = "status status-warning fas fa-cogs";
            this.tooltip = "Panel issue review is in progress.";
            this.statusName = "In progress";
        } else if (st === 'REVIEWED') {
            newClass = withpointer + " status status-open fas fa-check";
            this.tooltip = "Panel was reviewed.";
            this.statusName = "Reviewed";
        } else if (st == null) {
            newClass = "";
            this.tooltip = "";
            this.statusName = "";
        } else {
            newClass = withpointer + " status status-error fas fa-exclamation-circle";
            this.tooltip = "Unknown revision status. Please contact system administrator.";
            this.statusName = "Unknown";
        }
        if (!this.showStatusName) {
            this.statusName = "";
        }
        this.class = newClass;
    }
}

